import LabelLang, { LabelLangString } from "component/LabelLang/label-lang";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import Dropdown from "component/shared/dropdown/Dropdown";
import { END_POINTS } from "constants/APIConstant";
import { EXTERNAL_TRADE_BASE_URL } from "configs/AppConfig";
import { useEffect, useRef, useState } from "react";
import { Table } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import useSWR from "swr";
import Paginator from "component/shared/Paginator/Paginator";
import AutoCompleteComponent from "component/shared/AutoCompleteComponent";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { useReactToPrint } from "react-to-print";
import ReactGA from "react-ga4";

const CategoryGuide = () => {
  const intl = useIntl();

  const dir = useSelector(({ theme }) => theme.direction);
  const pdfImage = process.env.PUBLIC_URL + "/image/pdf.png";
  const excelImage = process.env.PUBLIC_URL + "/image/Excel.svg";
  const pdfHeader = process.env.PUBLIC_URL + "/image/pdfHeader.png";
  const pdfFooter = process.env.PUBLIC_URL + "/image/pdfFooter.png";
  const maxDate = new Date().toJSON().slice(0, 10);
  const currentLocale = useSelector(({ theme }) => theme.locale);

                              
  ReactGA.initialize(END_POINTS.TRACKING_ID)

  useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: "/external-trade", title: "Category-Guide External Trade Page" });
  }, []);


  const chaptersData = useSWR({
    url: `${EXTERNAL_TRADE_BASE_URL}/${END_POINTS.GET_ALL_CHAPTERS}`,
  });

  const [chapterId, setChapterId] = useState(0);
  const [chapterInfo, setChapterInfo] = useState();

  const defaultState = {
    subChapterId: null,
    currentPage: 1,
    pageSize: 10,
  };

  const [filters, setFilters] = useState(defaultState);
  const [filterCount, setFilterCount] = useState(defaultState);

  const handelChangeChapterId = (targetName) => {
    const result = chaptersData?.data?.data?.find(
      (item) =>
        item.code +
          " - " +
          LabelLangString({
            id: "name",
            currentLocale: currentLocale,
            defaultValue: item?.name,
            translations: item?.translations,
          }) ===
        targetName
    );
    if (result) {
      const idOfTargetName = result?.id;
      setChapterId(idOfTargetName);
      // setFilters(defaultState)
    }
    setChapterInfo(result);
    // setChapterInfo(chaptersData?.data?.data?.find(item => item.code+" - "+item.name === targetName));
    // setChapterInfo(chaptersData?.data?.data.find(el => +el.id === +e.target.value));
    // setChapterId(e.target.value);
    // setFilters(defaultState)
  };

  const subChaptersData = useSWR({
    url: chapterId
      ? `${EXTERNAL_TRADE_BASE_URL}/${END_POINTS.GET_SUB_CHAPTERS_BY_ID}${chapterId}`
      : null,
  });

  const [subChapterInfo, setSubChapterInfo] = useState();

  const handelChangeSubChapterId = (targetName) => {
    const result = subChaptersData?.data?.data?.subChapters.find(
      (item) =>
        item.code +
          " - " +
          LabelLangString({
            id: "name",
            currentLocale: currentLocale,
            defaultValue: item?.name,
            translations: item?.translations,
          }) ===
        targetName
    );
    if (result) {
      const idOfTargetName = result?.id;

      setFilters((prev) => ({
        ...prev,
        subChapterId: idOfTargetName,
      }));

      setFilterCount({
        currentPage: null,
        pageSize: null,
        subChapterId: idOfTargetName,
      });
    }
    setSubChapterInfo(result);
    // setSubChapterInfo(subChaptersData?.data?.data?.subChapters.find(item =>item.code+" - "+ item.name === targetName));
    // setSubChapterInfo(subChaptersData?.data?.data?.subChapters.find(el => +el.id === +e.target.value));
    // setFilters((prev) => ({
    //     ...prev,
    //     subChapterId: e.target.value
    // }));
  };

  const tableData = useSWR({
    url: filters.subChapterId
      ? `${EXTERNAL_TRADE_BASE_URL}/${END_POINTS.ITEM_GUIDE}`
      : null,
    params: filters,
  });

  const countFetching = useSWR({
    url: filters.subChapterId
      ? `${EXTERNAL_TRADE_BASE_URL}/${END_POINTS.ITEM_GUIDE}`
      : null,
    params: filterCount,
  });

  const onPageIndexChange = (e, value) => {
    setFilters((prev) => ({
      ...prev,
      currentPage: value,
    }));
  };

  const elementPdf = useRef(null);
  const generateToPDF = useReactToPrint({
    documentTitle: `${
      dir === "rtl" ? "دليل الأصنـاف" : "Items guide"
    } - ${LabelLangString({
      id: "name",
      currentLocale: currentLocale,
      defaultValue: chapterInfo?.name,
      translations: chapterInfo?.translations,
    })} - ${LabelLangString({
      id: "name",
      currentLocale: currentLocale,
      defaultValue: subChapterInfo?.name,
      translations: subChapterInfo?.translations,
    })}
        `,
    content: () => elementPdf.current,
    bodyClass: `${dir === 'rtl' ? 'exportBody-rtl' : 'exportBody-ltr'}`
  });

  return (
    <ContentLoading isLoading={chaptersData.isLoading}>
      <div className="active-item-news-tabs">
        <div className="browsetopic-box alls py-4 mb-0">
          <div className="container">
            <form className="row gy-3">
              <div className="col-12">
                <div className="item-form coll">
                  <label htmlFor="the-chapter">
                    <FormattedMessage id="the-chapter" />
                  </label>
                </div>
                {/* <Dropdown
                                item={chaptersData?.data?.data}
                                name={"the-chapter"}
                                placeholder={intl.formatMessage({id: "choose-chapter",})}
                                change={handelChangeChapterId}
                            /> */}
                <AutoCompleteComponent
                  handelChange={handelChangeChapterId}
                  item={chaptersData?.data?.data?.map((item) => ({
                    label:
                      item.code +
                      " - " +
                      LabelLangString({
                        id: "name",
                        currentLocale: currentLocale,
                        defaultValue: item?.name,
                        translations: item?.translations,
                      }),
                    id: item.id,
                  }))}
                />
              </div>

              <div className="col-12 ">
                <div className="item-form coll">
                  <label htmlFor="sub-chapter">
                    <FormattedMessage id="sub-chapter" />
                  </label>
                </div>
                {subChaptersData?.data?.data?.subChapters ? (
                  //      <Dropdown
                  //          item={subChaptersData?.data?.data?.subChapters}
                  //          name="sub-chapter"
                  //          placeholder={intl.formatMessage({ id: "choose-sub-chapter" })}
                  //          change={handelChangeSubChapterId}
                  //      />
                  <AutoCompleteComponent
                    handelChange={handelChangeSubChapterId}
                    item={subChaptersData?.data?.data?.subChapters.map(
                      (item) => ({
                        label:
                          item.code +
                          " - " +
                          LabelLangString({
                            id: "name",
                            currentLocale: currentLocale,
                            defaultValue: item?.name,
                            translations: item?.translations,
                          }),
                        id: item.id,
                      })
                    )}
                  />
                ) : (
                  <Dropdown
                    name="sub-chapter"
                    icon={false}
                    placeholder={
                      chapterId === 0
                        ? intl.formatMessage({ id: "choose-chapter-firstly" })
                        : intl.formatMessage({ id: "loading..." })
                    }
                  />
                )}
              </div>
              <div className="col-12 col-lg-4 "></div>
              <div className="col-12 col-lg-8 ">
                <div className="row-r gap-4 my-3 align-items-center">
                  {countFetching?.data?.data &&
                    Object.keys(countFetching?.data?.data).length > 0 && (
                      <div className="text-white">
                        <span>
                          <FormattedMessage id="download-data" />
                        </span>
                        <span
                          className={`content ${
                            dir === "rtl" ? "me-3" : "ms-3"
                          }`}
                        >
                          <span
                            className={`sp-icon ${
                              dir === "rtl" ? "ms-3" : "me-3"
                            }`}
                            onClick={() => {
                              generateToPDF();
                            }}
                          >
                            <img
                              src={pdfImage}
                              style={{
                                width: "40px",
                                cursor: "pointer",
                                borderRadius: "6px",
                              }}
                              alt="pdf-image"
                            />
                          </span>
                          <ReactHTMLTableToExcel
                            id="test-table-xls-button"
                            className={`border-0 bg-transparent`}
                            table={`table-to-xls-category-guide-report`}
                            filename={`${
                              dir === "rtl" ? "دليل الأصنـاف" : "Items guide"
                            } - ${LabelLangString({
                              id: "name",
                              currentLocale: currentLocale,
                              defaultValue: chapterInfo?.name,
                              translations: chapterInfo?.translations,
                            })} - ${LabelLangString({
                              id: "name",
                              currentLocale: currentLocale,
                              defaultValue: subChapterInfo?.name,
                              translations: subChapterInfo?.translations,
                            })}
                                                    `}
                            sheet="tablexls"
                            buttonText={
                              <span className="sp-icon">
                                <img
                                  src={excelImage}
                                  style={{
                                    width: "40px",
                                    cursor: "pointer",
                                    borderRadius: "6px",
                                  }}
                                  alt="excel-image"
                                />
                              </span>
                            }
                          />
                        </span>
                      </div>
                    )}
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="body-news pt-4">
          {tableData?.isLoading ? (
            <h5 className="text-center" dir="ltr">
              <FormattedMessage id="loading..." />
            </h5>
          ) : tableData?.data?.data && chapterInfo && subChapterInfo ? (
            Object.keys(tableData?.data?.data).length > 0 ? (
              <>
                <h6 className="text-black fw-semibold text-center mb-3">
                  {LabelLangString({
                    id: "name",
                    currentLocale: currentLocale,
                    defaultValue: chapterInfo?.name,
                    translations: chapterInfo?.translations,
                  })}{" "}
                  -{" "}
                  {LabelLangString({
                    id: "name",
                    currentLocale: currentLocale,
                    defaultValue: subChapterInfo?.name,
                    translations: subChapterInfo?.translations,
                  })}
                </h6>
                <Table
                  responsive
                  striped
                  bordered
                  hover
                  className="text-center"
                >
                  <caption className="pt-3 pb-0">
                    {LabelLangString({
                      id: "name",
                      currentLocale: currentLocale,
                      defaultValue: chapterInfo?.name,
                      translations: chapterInfo?.translations,
                    })}{" "}
                    -{" "}
                    {LabelLangString({
                      id: "name",
                      currentLocale: currentLocale,
                      defaultValue: subChapterInfo?.name,
                      translations: subChapterInfo?.translations,
                    })}{" "}
                    -{" "}{dir === "rtl" ? "دليل الأصنـاف" : "Items guide"}
                  </caption>
                  <thead
                    className="text-white main-bg"
                    
                  >
                    <tr>
                      <th style={{ width: "5%" }}>#</th>
                      <th style={{ width: "15%" }}>
                        {intl.formatMessage({ id: "category-code" })}
                      </th>
                      <th>{intl.formatMessage({ id: "category-name" })}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <Paginator
                      size={filters.pageSize}
                      table={true}
                      change={onPageIndexChange}
                      page={filters.currentPage}
                      totalCount={tableData?.data?.page?.totalCount}
                    >
                      {tableData?.data?.data.map(
                        ({ name, hsn, itemTranslations }, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>
                              {hsn ? (
                                hsn
                              ) : (
                                <mark
                                  className="rounded text-white p-1 second-bg"
                                >
                                  N/A
                                </mark>
                              )}
                            </td>
                            <td>
                              <LabelLang
                                id="name"
                                defaultValue={name}
                                translations={itemTranslations}
                              />
                            </td>
                          </tr>
                        )
                      )}
                    </Paginator>
                  </tbody>
                </Table>

                <div className="d-none">
                  <div ref={elementPdf}>
                    <img
                      src={pdfHeader}
                      alt="pdf-header"
                      className="w-100"
                      style={{
                        // position: "fixed",
                        top: "5px",
                        left: 1,
                        zIndex: 100000,
                      }}
                    />
                    <h6 className="text-black fw-semibold text-center mb-3">
                      {LabelLangString({
                        id: "name",
                        currentLocale: currentLocale,
                        defaultValue: chapterInfo?.name,
                        translations: chapterInfo?.translations,
                      })}{" "}
                      -{" "}
                      {LabelLangString({
                        id: "name",
                        currentLocale: currentLocale,
                        defaultValue: subChapterInfo?.name,
                        translations: subChapterInfo?.translations,
                      })}
                    </h6>
                    <Table
                      responsive
                      striped
                      bordered
                      hover
                      className="text-center"
                      id={`table-to-xls-category-guide-report`}
                    >
                      <caption className="pt-3 pb-0">
                        {LabelLangString({
                          id: "name",
                          currentLocale: currentLocale,
                          defaultValue: chapterInfo?.name,
                          translations: chapterInfo?.translations,
                        })}{" "}
                        -{" "}
                        {LabelLangString({
                          id: "name",
                          currentLocale: currentLocale,
                          defaultValue: subChapterInfo?.name,
                          translations: subChapterInfo?.translations,
                        })}{" "}
                        -{" "}{dir === "rtl" ? "دليل الأصنـاف" : "Items guide"}
                      </caption>
                      <thead
                        className="text-white main-bg"
                        
                      >
                        <tr>
                          <th colSpan={3}>{maxDate}</th>
                        </tr>
                        <tr>
                          <th style={{ width: "5%" }}>#</th>
                          <th style={{ width: "15%" }}>
                            {intl.formatMessage({ id: "category-code" })}
                          </th>
                          <th>{intl.formatMessage({ id: "category-name" })}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {countFetching?.data?.data.map(
                          ({ name, hsn, itemTranslations }, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>
                                {hsn ? (
                                  hsn
                                ) : (
                                  <mark
                                    className="rounded text-white p-1 second-bg"
                                  >
                                    N/A
                                  </mark>
                                )}
                              </td>
                              <td>
                                <LabelLang
                                  id="name"
                                  defaultValue={name}
                                  translations={itemTranslations}
                                />
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </Table>
                    <img
                      src={pdfFooter}
                      alt="pdf-footer"
                      className="w-100"
                      style={{
                        // position: "fixed",
                        bottom: "10px",
                        left: 1,
                        zIndex: 100000,
                      }}
                    />
                  </div>
                </div>
              </>
            ) : (
              <h4 className="text-center">
                <FormattedMessage id="data-not-found" />
              </h4>
            )
          ) : (
            ""
          )}
        </div>
      </div>
    </ContentLoading>
  );
};

export default CategoryGuide;
